import React from 'react';
import Relay from 'react-relay';
import mergeWith from 'lodash/mergeWith'
import pickBy from 'lodash/pickBy'

import Button from '../../components/Button';
import ChatTable from '../../components/ChatTable';
import { isValidEmailAddress } from '../../components/UserPanel';

import UpdateUserMutation from '../../mutations/User/UpdateUserMutation';

const pageSize = 100;

class ChatsList extends React.Component {

  state = {
    search: '',
    loading: false,
  }

  constructor(props) {
    super(props);
  }

  componentWillMount(){
    this.componentWillReceiveProps(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.loading) return false

    const existFirst = (objValue, srcValue) => objValue? objValue : srcValue
    const propsWithDefaults = mergeWith(nextProps, this.state, existFirst)
    const { search /*, searchByUserType, searchBySportId, searchBySportLevel*/ } = propsWithDefaults
    this.hasNextPage = nextProps.viewer.next ? nextProps.viewer.next.pageInfo.hasPreviousPage : this.hasNextPage;
    this.hasPreviousPage = nextProps.viewer.prev ? nextProps.viewer.prev.pageInfo.hasNextPage : this.hasPreviousPage;

    const variables = {}

    // if (search !== this.props.search || search !== this.state.search) {
    //   if (isValidEmailAddress(search)) {
    //     variables.email = search
    //   } else {
    //     variables.pseudo = search
    //   }
    //   if (search !== this.state.search) {
    //     this.setState({
    //       search
    //     })
    //   }
    // }
    //
    // if (searchByUserType != this.props.relay.variables.userType) {
    //   variables.userType = searchByUserType
    // }
    //
    // if (searchBySportId && (searchBySportId != (this.props.relay.variables.sport || {}).sportID)) {
    //   variables.sport = { sportID: searchBySportId }
    // }
    //
    //
    // if (variables.sport && searchBySportLevel && (searchBySportLevel != (this.props.relay.variables.sport || {}).level)) {
    //   variables.sport.level = searchBySportLevel
    // }

    if (Object.keys(variables).length) {
      this.setState({
        loading: true,
      })
      this.props.relay.setVariables(variables, (state) =>
        (state.done || state.aborted) && this.setState({
          loading: false,
        })
      )
    }
  }

  nextPage() {
    this.hasPreviousPage = true;
    const pageInfo = this.props.viewer.next ? this.props.viewer.next.pageInfo : this.props.viewer.prev.pageInfo;
    const cursor = pageInfo.startCursor;
    this.setState({ loading: true })
    this.props.relay.setVariables({
      before: cursor,
      next: true,
      prev: false
    }, ({ done, aborted }) => (done || aborted) && this.setState({ loading: false }));
  }

  prevPage() {
    this.hasNextPage = true;
    const pageInfo = this.props.viewer.next ? this.props.viewer.next.pageInfo : this.props.viewer.prev.pageInfo;
    const cursor = pageInfo.endCursor;
    this.setState({ loading: true })
    this.props.relay.setVariables({
      after: cursor,
      next: false,
      prev: true
    }, ({ done, aborted }) => (done || aborted) && this.setState({ loading: false }));
  }

  assetEdges() {
    // get the next edges or the prev edges, or just get an empty array
    return (this.props.viewer ?
      (this.props.viewer.next ? this.props.viewer.next.edges :
        (this.props.viewer.prev ? this.props.viewer.prev.edges : []))
      : [])
  }

  onEditChatClick = (item, index) => {
    if(item == this.props.location.state.user){
      return;
    }

    let path = '/chats/edit/'+item.id;
    this.props.router.push({
      pathname : path,
      state :{
        chatId:item.id,
      }
    })
  }

  render() {
    if (this.state.loading) return (<div>Loading...</div>)

    const prevButton = this.hasPreviousPage ? <button onClick={ this.prevPage.bind(this) }>Prev</button> : '';
    const nextButton = this.hasNextPage ? <button onClick={ this.nextPage.bind(this) }>Next</button> : '';

    // const chats = this.props.viewer.chats.edges;
    const chats = this.assetEdges();
    let filter = this.props.location.state.filter;

    return (
      <div>
         <ChatTable
          dataSource={chats}
          filter={filter}
          onItemClick={this.onEditChatClick}/>
        {this.props.children}
        { prevButton } { nextButton }
      </div>
    );

  }

}

ChatsList.propTypes = ({
  viewer: React.PropTypes.object.isRequired,
  relay: React.PropTypes.object.isRequired,
  children: React.PropTypes.node,
});

export default Relay.createContainer(ChatsList, {
  initialVariables: {
    // filter: null,
    first: pageSize,
    last: pageSize,
    after: null,
    before: null,
    next: true,
    prev: false,
    // pseudo: null,
    // email: null,
    // sport: null,
    // userType: null,
  },

  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        next: chats(last: $last, before: $before) @include(if: $next) {
          edges {
            node {
              id
              users {
                id
                pseudo
              }
              sportunity {
                id
                title
              }
              isActive
              messageCount
              messages(first:2) {
                edges {
                  node {
                    id
                    author {
                      id
                      pseudo
                    }
                    text
                    created
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }

        prev: chats(first: $first, after: $after) @include(if: $prev) {
          edges {
            node {
              id
              users {
                id
                pseudo
              }
              sportunity {
                id
                title
              }
              isActive
              messageCount
              messages(first:2) {
                edges {
                  node {
                    id
                    author {
                      id
                      pseudo
                    }
                    text
                    created
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
      `,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Chats/ChatsList.js